import { Injectable } from '@angular/core';

import { map, Observable } from 'rxjs';

import { SeasonEvent } from '@reg/shared/model';
import { HttpServiceHelper } from '@reg/shared/service/http-service-helper';
import { IJsonApiResponse } from '../json-api/json-api.interface';

/**
 * Service to get and save seasonEvent data.
 */
@Injectable()
export class SeasonEventService {
    constructor(private http: HttpServiceHelper) {
    }

    /**
     * Add or update the seasonEvent
     */
    public save(seasonEvent: SeasonEvent): Observable<SeasonEvent> {
        let response: Observable<IJsonApiResponse>;

        if (!seasonEvent.isNew) {
            // Update existing SeasonEvent
            response = this.http.patch(this.getApiUrl(seasonEvent.id), seasonEvent.serialize());
        } else {
            // Add a new SeasonEvent
            response = this.http.post(this.getApiUrl(null), seasonEvent.serialize());
        }

        return response.pipe(map((response: IJsonApiResponse) => (new SeasonEvent()).deserialize(response)));
    }

    /**
     * Delete the specified seasonEvent.
     */
    public delete(seasonEventId: string): Observable<boolean> {
        return this.http.delete(this.getApiUrl(seasonEventId)).pipe(map(() => true));
    }

    /**
     * Build the api's url based on the given parameters
     */
    private getApiUrl(seasonEventId: string): string {
        let url: string = `${this.http.configService.getApiBaseUrl()}/season-events/`;

        if (seasonEventId) {
            url += seasonEventId;
        }

        return url;
    }
}
